import React from 'react'
import {EmojiUtils} from '@extensions/emoji-utils'
import {EmojiProps} from './types'

export const Emoji = React.memo(({value, className}: EmojiProps) => {
  const html = value?.replace('❤', '❤️')?.replace('✔', '✔️') || ''

  return (
    <span
      className={className}
      dangerouslySetInnerHTML={{__html: EmojiUtils.safeParse(html, true)}}
    />
  )
})
